import React from 'react'

import Grid from 'components/Grid'
import { FixedImage } from 'components/NextImage'

import classes from './MoreIntegrations.module.scss'

/** @type {import("./types").default} */
const MoreIntegrations = ({ restIntegrations }) => {
  return (
    <Grid container className={classes.moreIntegrations}>
      {restIntegrations.map(({ name, logoUrl }) => (
        <div key={`integration_${name}`}>
          <div className={classes.integration}>
            <FixedImage src={logoUrl} alt={name} height={32} width={32} />
            <span>{name}</span>
          </div>
        </div>
      ))}
    </Grid>
  )
}

export default MoreIntegrations
